import { IKVProps } from "@src/Model/IKVProps"
import AxiosRequest from "@src/Utils/axios"
import internationalPackageAxiosRequest from '@src/Utils/internationPackageAxios'
import axios from "axios"

export function queryLanguageResource(params: IKVProps = {}) {
  return AxiosRequest.post('/websiteApi/operation-manager/international/language/v2/listCommonMoreLanguage', params)
}
export function queryLanguageList(params: IKVProps = {}) {
  return AxiosRequest.post('/websiteApi/operation-manager/dictionary/listLanguage', params)
}
export function getPackagesList(params: IKVProps = {}) {
  // Boss (睿管家) 的 Android 版本统一转换为 RSManager
  let processedParams = { ...params };
  if (params.app_type === "Boss" && params.app_sub_type?.includes("Android")) {
    processedParams = {
      ...params,
      app_type: "RSManager",
      app_sub_type: "Android_RSManager",
    };
  }
  return AxiosRequest.post('/packages/list', processedParams)
}
// export function getRegionPackagesListDev(params: IKVProps = {}, region?: string) {
//   return AxiosRequest.post('/_localReqRP/packages/list', params)
// }
export function getRegionPackagesList(region: string, params: IKVProps = {},) {
  // 默认是新加坡的
  const _rigion = region === "sea" ? "" : region
  return internationalPackageAxiosRequest.post(`/http://packages.${_rigion}.restosuite.ai/packages/list`, params)
}

export function getDefaultOfficialList(params: IKVProps = {}) {
  return AxiosRequest.get('/packages/default_official/list', params)
}

/**
 * 获取 eu/us 区域的包列表（直接请求，不经过代理）
 * @param region 区域：'eu' 或 'us'
 * @param params 请求参数
 * @returns Promise，返回的响应结构为 { code, data: { list } }（两层 data）
 */
export function getRegionPackagesListDirect(region: "eu" | "us", params: IKVProps = {}) {
  // Boss (睿管家) 的 Android 版本统一转换为 RSManager
  let processedParams = { ...params };
  if (params.app_type === "Boss" && params.app_sub_type?.includes("Android")) {
    processedParams = {
      ...params,
      app_type: "RSManager",
      app_sub_type: "Android_RSManager",
    };
  }

  return axios.post(
    `${location.protocol}//packages.${region}.restosuite.ai/packages/list`,
    processedParams
  );
}
